module.exports = __webpack_public_path__ + "img/partners4.b78ed3a6.png";